import React from "react";
import "../../styles/dashboardStyle/CardRanking.css";

interface CardRankingProps {
  titulo: string;
  dados: { nome: string; valor: number }[];
}

export default function CardRanking({ titulo, dados }: CardRankingProps) {
  return (
    <div className="card-ranking">
      <div className="card-ranking-header">
        <h2>{titulo}</h2>
      </div>
      <div className="card-ranking-body">
        <ul>
          {dados.map((item, index) => (
            <li key={index} className="card-ranking-item">
              <span className="item-nome">
                {index + 1}. {item.nome}
              </span>
              <span className="item-valor">{item.valor}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
